export default __webpack_public_path__ + "static/media/instagram.4510ec0a.svg";